var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"1.41 17.41 10.12 8.71 1.41 0 0 1.41 7.29 8.71 0 16 1.41 17.41"}));
}

ChevronRight.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 10.12 17.41"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
